<template>
    <div id="editAuthId">
        <form @submit.prevent="saveEditAuthId" ref="formeditAuthId" >
        <div class="card-header">
            <div class="row">
                <div class="col-6"><h3>Auth Identification</h3></div>
                <div class="col-6 text-right">
                    <button type="submit" class="btn btn-success btn-md" :disabled="isLoading" >Save</button>
                    <button type="button" class="btn btn-light btn-md" @click="$parent.close">Cancel</button>
                </div>
            </div>
        </div>
        <div v-if="isLoading"><Loader></Loader></div>
            <div class="card-body" v-else>
                <div class="alert alert-dark" role="alert">
                    <b>Info: </b> Account ID number; you can add a phone number to use as your ID.<br />
                    To authenticate your app, you can use your system ID or assigned phone number, both will be valid.
                    Write the phone number, do not use characters, symbols or spaces,  Ex: 7745551234
                </div>
                <div class="form-group">
                    <label for="authId">Auth Id: <small>(System Id)</small></label>
                    <div class="input-group mb-3">
                        <input type="text" class="form-control" v-model="idAuth" id="authId" style="font-size: 20px"  readonly>
                    </div>
                </div>
                <div class="form-group">
                    <label for="phoneNumber">Phone Number: <small>(Custom Id)</small></label>
                    <div class="input-group mb-3">
                        <input type="text" class="form-control" v-model="phone" id="phoneNumber" style="font-size: 20px" placeholder="7745551234" maxlength="10" minlength="10">
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import Loader from "@/core/components/shared/Loader.vue";
export default {
    name: "editAuthId",
    components: {
        Loader,
    },
    data() {
        return {
			// @ts-ignore
			org_id: window.localorgdata,
			// @ts-ignore
			user_id: window.master_client,
            isLoading: false,
            phone: null,
            idAuth: null,
        };
    },
    created() {
        this.idAuth = this.user_id + this.org_id.padStart(4, '0');
        this.getOtpCustomId();
    },
    methods: {
        getOtpCustomId(){
			let t = this;
			t.isLoading = true;
				// @ts-ignore
			window.master.post('bRem/getOtpCustomId', {
				org_id: this.org_id,
				user_id: this.user_id,
			})
			.then((response) => {
				t.isLoading = false;
				console.log('bRem loaded', response.data);
                if(response.data?.success){
                    this.phone = response.data.custom_id;
                }
			}).catch((error) => {
				t.isLoading = false;
				console.log(error);
                this.$store.commit('core/setNotiPush', {
                    show: true,
                    group: "notiPush",
                    type: '3', // 1=success|2=info|3=error|4=loading|5=warning
                    title: 'Error',
                    text: error.message ?? 'Server error.',
                    duration: 5000
                });
			});
        },
        saveEditAuthId(){
			let t = this;
			t.isLoading = true;
				// @ts-ignore
			window.master.post('bRem/setOtpCustomId', {
				org_id: this.org_id,
				user_id: this.user_id,
				custom_id: this.phone,
			})
			.then((response) => {
				t.isLoading = false;
				console.log('bRem loaded', response.data);
                if(response.data.success){
                    this.$emit('saveCustomId')
                    this.$parent.close();
                }else {
                    this.$store.commit('core/setNotiPush', {
                        show: true,
                        group: "notiPush",
                        type: '3', // 1=success|2=info|3=error|4=loading|5=warning
                        title: 'Error',
                        text: response.data.message,
                        duration: 15000
                    });
                }
			}).catch((error) => {
				t.isLoading = false;
				console.log(error);
                this.$store.commit('core/setNotiPush', {
                    show: true,
                    group: "notiPush",
                    type: '3', // 1=success|2=info|3=error|4=loading|5=warning
                    title: 'Error',
                    text: error.message ?? 'Server error.',
                    duration: 15000
                });
			});
        }
    }
};
</script>
<style lang="scss" scoped>
#editAuthId {
    .card-header{
        padding-top: 10px;
        padding-bottom:5px;
    }
    .card-body {
        height: 400px;
        overflow: hidden;
        overflow-y: auto;
        padding-bottom:50px;
        padding-top: 5px;
    }
    .btn-light {background: #fff; border: 1px solid #ccc; margin-left:25px;}
    .form-control {
        letter-spacing: 3px;
    }
}
</style>
